import React from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import { FiImage, FiUploadCloud, FiChevronLeft, FiGrid } from "react-icons/fi";
import { useTranslation } from "react-i18next";

export default function EventTabNav({ onBack }) {
  const { id_name } = useParams();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const tabs = [
    {
      Icon: FiGrid,
      label: t("event_tab_nav.overview"),
      path: `/admin/overview/${id_name}`,
    },
    {
      Icon: FiImage,
      label: t("event_tab_nav.gallery"),
      path: `/admin/${id_name}`,
    },
    {
      Icon: FiUploadCloud,
      label: t("event_tab_nav.upload"),
      path: `/admin/upload/${id_name}`,
    },
  ];

  const isActive = (path) =>
    pathname === path || pathname === `${path}/`;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        background: "#fff",
        borderBottom: "1px solid #f0f0f0",
        padding: "0 16px",
        overflowX: "auto",
      }}
    >
      {/* Back to My Events */}
      <button
        onClick={onBack}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 5,
          height: 44,
          padding: "0 10px 0 0",
          background: "none",
          border: "none",
          cursor: "pointer",
          fontSize: 12,
          fontWeight: 600,
          color: "#6b7280",
          flexShrink: 0,
          transition: "color 0.15s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.color = "#374151")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "#6b7280")}
      >
        <FiChevronLeft size={14} />
        {t("event_tab_nav.my_events")}
      </button>

      {/* Divider */}
      <div
        style={{
          width: 1,
          height: 18,
          background: "#e5e7eb",
          marginRight: 6,
          flexShrink: 0,
        }}
      />

      {/* Tabs */}
      {tabs.map(({ Icon, label, path }) => {
        const active = isActive(path);
        return (
          <Link
            key={path}
            to={path}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              height: 44,
              padding: "0 14px",
              fontSize: 13,
              fontWeight: active ? 600 : 500,
              color: active ? "#6366f1" : "#6b7280",
              borderBottom: `2px solid ${active ? "#6366f1" : "transparent"}`,
              textDecoration: "none",
              whiteSpace: "nowrap",
              flexShrink: 0,
              transition: "color 0.15s, border-color 0.15s",
            }}
          >
            <Icon size={14} aria-hidden="true" />
            {label}
          </Link>
        );
      })}
    </div>
  );
}
